﻿$.fn.dxCtrlPlanitiReunionDetail = function custom_dxCtrlPlanitiReunionDetail(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlplanitireuniondetail dx-ctrl");
        this.createInstance(new cdxCtrlPlanitiReunionDetail(this, option));
    }
    return this;
}

window.cdxCtrlPlanitiReunionDetail = function (container, option) {
    var Me = this;


    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }

    function mConstruit() {
        container.empty();

        var $DivDate = $("<div/>").appendTo(container)
        $DivDate.css("text-decoration", ((option.planitiReunion.date_debut < parametre.dateNow) ? "line-through" : ""))
        $("<div style='font-weight:bold;font-size:160%;'>Le <b>" + DevExpress.localization.formatDate(option.planitiReunion.date_debut, "eeee d MMMM yyyy") + "</b> de <b><u>" + DevExpress.localization.formatDate(option.planitiReunion.date_debut, "HH:mm") + "</u></b> à <b><u>" + DevExpress.localization.formatDate(option.planitiReunion.date_fin, "HH:mm") + "</u></b></div>").appendTo($DivDate)

        $("<div style='font-weight:bold;font-size:140%;margin:25px 0 5px 0;' class='dx-theme-accent-as-text-color'>Lieu</div>").appendTo(container)
        switch (parseInt(option.planitiReunion.id_type_lieu)) {
            case 0://tel
                $("<div>Cette réunion se déroulera au téléphone</div>").appendTo(container)
                $("<div style='font-size:120%;'>Vous serez appelé à l'heure de la réunion sur le <b><u>" + option.planitiReunion.tel_sms_appel + "</u></b></div>").appendTo(container)
                break;
            case 1://zoom
                $("<div>Cette réunion se déroulera via une conférence vidéo Zoom</div>").appendTo($Div)
                $("<div style='font-size:120%;'>A l'heure de la réunion, vous pourrez vous connecter via le lien zoom suivant:</div>").appendTo(container)
                $("<a style='font-size:120%;' href='" + option.planitiReunion.url_invite_zoom + "'>" + option.planitiReunion.url_invite_zoom + "</a>").appendTo(container)
                break;
        }

        if (typeof option.planitiReunion.lst_email != 'undefined' && option.planitiReunion.lst_email.length > 0) {
            $("<div style='font-weight:bold;font-size:140%;margin:25px 0 5px 0;' class='dx-theme-accent-as-text-color'>Invité (" + option.planitiReunion.lst_email.length + ")</div>").appendTo($Div)
            option.planitiReunion.lst_email.forEach(function (email) {
                $("<div><u>" + email + "</u></div>").appendTo(container)
            })
        }
        if (option.bddCtrl.isAuthentified() && option.bddCtrl.utiCourant.id_utilisateur > 99999) {
            $("<div style='width:100%;'/>").appendTo(container).dxTextArea({
                label: "Commentaire interne",
                labelMode: 'floating',
                value: option.planitiReunion.commentaire,
                onValueChanged: function (e) {
                    option.planitiReunion.commentaire = ((e.value == null) ? "" : e.value)
                    option.bddCtrl.getObjet(option.planitiReunion).mSaveChamp("commentaire")
                }
            })
        }

    }

    this.element = function () { return container; }

    mConstruit();
}